import { API_HOST, API_PORT, API_SCHEME, HEADER_AUTHORIZATION, LOCAL_STORAGE_BEARER_TOKEN_KEY } from "../constants";

export const callApi = (uri: string = '', bearerToken: string = '', method: string = 'GET', body: any = null) => {
  if (method !== 'GET' && body) {
    body = JSON.stringify(body);
  }

  let headers = {
    "Content-Type": "application/json",
  };

  if (bearerToken) {
    headers = Object.assign({}, headers, {
      [HEADER_AUTHORIZATION]: `Bearer ${bearerToken}`,
    });
  }

  return fetch(`${API_SCHEME}://${API_HOST}:${API_PORT}${uri}`, {
    method,
    headers,
    body,
    // credentials: 'include',
  }).then(r => {
    if (r.status === 401) {
      localStorage.setItem(LOCAL_STORAGE_BEARER_TOKEN_KEY, '');
      window.location.reload();
      return;
    }
    return r.json();
  });
};
